import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from '../../config/constants';

export const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: '#312f3d',
        color: theme.palette.secondary.main,
        fontSize: '16px',
        paddingTop: '100px',
        paddingBottom: '200px',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginTop: '60px',
        },
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            marginTop: '120px',
        },
        [theme.breakpoints.down('sm')]: {
            paddingTop: '50px',
            paddingBottom: '50px',
        },
        '& a': {
            color: '#b3b8c1',
            textDecoration: 'none',
        },
        '& a:hover': {
            color: '#ff5a60',
            textDecoration: 'none',
        },
    },
    containerMobile: {
        flexDirection: 'column',
        [theme.breakpoints.down('md')]: {
            paddingLeft: '4rem',
        },
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            paddingLeft: '15px',
            paddingRight: '15px',
        },
    },
    grid: {
        [theme.breakpoints.up(576)]: {
            maxWidth: '540px',
        },
        [theme.breakpoints.up(768)]: {
            maxWidth: '720px',
        },
        [theme.breakpoints.up(992)]: {
            maxWidth: '960px',
        },
        [theme.breakpoints.up(1200)]: {
            maxWidth: '1140px',
        },
        [theme.breakpoints.up(1600)]: {
            maxWidth: '1500px',
        },
    },
    appStoresLinks: {
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        color: 'white',
    },
    appStoreLinkIcon: {
        maxHeight: '43px',
    },
    linksGrid: {},
    appLinksTitle: {
        fontSize: '1.25rem',
        fontWeight: 400,
        color: 'white',
        marginTop: 0,
        marginBottom: '8px',
    },
    appLinksDescription: {
        fontSize: '16px',
        fontWeight: 400,
        color: 'white',
        marginBottom: '1rem',
    },
    mobileLinks: {
        display: 'flex',
        flexDirection: 'row',
        gap: '15px',
    },
    logo: {
        width: '200px',
        height: '65px',
    },
    mobileLogo: {
        maxHeight: '30px',
        marginBottom: '12px',
    },
    bottomMargin: {
        marginBottom: '3rem',
    },
    bottomMarginSmall: {
        marginBottom: '1.5rem',
    },
    mobileCopyright: {
        marginTop: '1rem',
    },
}));
